var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      staticClass: "modal-ReceivedCoupon",
      attrs: {
        name: _vm.modalName,
        "show-close": true,
        "cover-closeable": false,
        "close-btn-handler": _vm.handleClose,
      },
      on: { modalClose: _vm.handleClose },
    },
    [
      _c(
        "div",
        {
          staticClass: "content",
          attrs: { slot: "modal-content" },
          slot: "modal-content",
        },
        [
          _c("div", {
            staticClass: "jumpGasUrlBtn",
            on: { click: _vm.jumpGasUrl },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }